/**
 * UUID v4를 생성하는 함수
 * @returns {string} UUID v4 문자열
 */
export function generateUUID(): string {
  // crypto.randomUUID()는 브라우저에서 지원되는 표준 API입니다
  return crypto.randomUUID();
}
